import { SEARCH, SEARCH_ERROR, SEARCH_SUCCESS } from "core-web/state/models/Search/constants";

import getQueryParams from "core-web/utils/getQueryParams";
import store from "core-web/state/store";

export const search = (query, history, location) => (dispatch) => {
    dispatch({ type: SEARCH });
    try {
        const params = getQueryParams(location);
        params.q = encodeURI(query);

        if (query) {
            try {
                params.q = decodeURI(query);
            } catch (e) {
                console.error(e, "Failed decode in dispatch");
            }
        } else {
            delete params.q;
        }

        history.replace(
            `?${Object.entries(params)
                .map((q) => q.join("="))
                .join("&")}`,
        );

        dispatch({
            type: SEARCH_SUCCESS,
            query,
        });
    } catch (e) {
        dispatch({ type: SEARCH_ERROR });
        throw e;
    }
};

export default (query, history, location) => store.dispatch(search(query, history, location));
